import { jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ jsx("svg", { width: 9, height: 14, viewBox: "0 0 9 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M1 1L7 7L1 13", stroke: "currentColor", strokeWidth: 2 }) });
export default SvgChevronRight;
